import api from './base-api';

const notificationsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		logClient: builder.mutation({
			query: (body: any) => ({
				url: '/notifications/log-client',
				method: 'POST',
				body,
			}),
			extraOptions: { skipAuth: true },
		}),
	}),
	overrideExisting: false,
});

export const { useLogClientMutation } = notificationsApi;
